import type { ReactNode } from 'react';

/**
 * Right-hand card of the Context row — a titled metadata grid. Callers pass
 * <MetaItem /> children with operation-specific fields.
 *
 * See docs/FeatureDesigns/operation-detail-unified-layout.md.
 */
export interface MetadataCardProps {
    title: string;
    children: ReactNode;
}

export function MetadataCard({ title, children }: MetadataCardProps) {
    return (
        <div className="card metadata-card">
            <h3>{title}</h3>
            <div className="metadata-grid">{children}</div>
        </div>
    );
}

export interface MetaItemProps {
    label: string;
    children: ReactNode;
    className?: string;
}

/** Label/value cell inside MetadataCard's grid. String children auto-wrap in <span>. */
export function MetaItem({ label, children, className }: MetaItemProps) {
    return (
        <div className={`meta-item${className ? ' ' + className : ''}`}>
            <label>{label}</label>
            {typeof children === 'string' || typeof children === 'number'
                ? <span>{children}</span>
                : children}
        </div>
    );
}
